module.exports = __webpack_public_path__ + "static/img/2993x.4a5f853.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2993x.png
// module id = JYOn
// module chunks = 1